import { render, staticRenderFns } from "./ProductTag.vue?vue&type=template&id=607a9e8c&scoped=true&"
import script from "./ProductTag.vue?vue&type=script&lang=js&"
export * from "./ProductTag.vue?vue&type=script&lang=js&"
import style0 from "./ProductTag.vue?vue&type=style&index=0&id=607a9e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607a9e8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
